import { useEffect, useState } from "react";
import swal from 'sweetalert2';
import { getOrderItem, postProcessRefund } from "../api/fnbAPI";
import Swal from 'sweetalert2'; 

const webURL = window.location.host.indexOf('localhost') >= 0 ? 'http://localhost:3000' : 'https://dev-ogr.golfez.in';

const EditFnbCancellation = (props) => {
    const [fnbCancellationDetails, setFnbCancellationDetails]   = useState({});
    const [orderItem,                      setOrderItem]        = useState([]);

    useEffect(() => {
        $('#editFnbCancellationModal').modal({ backdrop: 'static' });
        $('#editFnbCancellationModal').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');   
            props.onDismissModal(null); 
        });
    }, []);

    useEffect(() => {
        if (props.fnbCancellationDetails) { 
            fetchFnbOrderItem(props.fnbCancellationDetails.ID)
            setFnbCancellationDetails({ ...props.fnbCancellationDetails });
        }
    }, [props.fnbCancellationDetails]);

    const updateFnbCancellationDetails = (field, value) => { 
        setFnbCancellationDetails((prev) => ({ ...prev, [field]: value }));
    };

    const fetchFnbOrderItem = async(orderId) => {
        try {
            const order = await getOrderItem(orderId);
            setOrderItem(order)
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    const submitFnbCancellation = async (e) => {
        e.preventDefault()

        var form = $('#fnbCancellationForm');
        
        form.validate({
            rules: {
                txtRefNo: {
                    required: true,
                },
                txtRefAmount: {
                    required: true,
                }                         
            },
            messages: {
                txtRefNo: {
                    required: "Please enter Ref No"
                },
                txtRefAmount: {
                    required: "Please enter Ref Amount"
                }
            }
        });
        if (!form.valid()) return;
        try {
            await postProcessRefund({
                OrderID: fnbCancellationDetails.ID, 
                RefundRefNo: fnbCancellationDetails.RefundRefNo, 
                RefundAmt: fnbCancellationDetails.RefundAmt, 
                RefundComment: fnbCancellationDetails.RefundComment
            });
            swal.fire({
                icon: 'success',
                titleText: 'Cancellation updated successfully!',
                showConfirmButton: false,
                timer: 1500,
            });
            setFnbCancellationDetails({})
            $('#editFnbCancellationModal').modal('hide');
            
        } catch (err) {
            swal.fire({
                icon: 'error',
                titleText: 'Error!',
                text: err.message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand',
            });
            return
        } 
        props.refetchData();
        form.clearForm();
        form.validate().resetForm();
    };
    const viewForm = () => {
        
        // window.open(`http://localhost:3000/invoice?id=${bookSheet.TransactionID}`, '_blank', 'noopener');
        window.open(`${webURL}/invoice?id=${fnbCancellationDetails.TransactionID}`, '_blank', 'noopener');
    };

    return (
        <div className="modal fade" id="editFnbCancellationModal" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Order Details</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div id="modalMessageHolder" style={{ display: 'none' }}></div>
                            <div className="row" style={{color: '#181c32', fontWeight: '600'}}>
                                <div className="col-sm-6">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Bill No: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <div className="margin-0">&nbsp;<span id="lblBillNo">{fnbCancellationDetails.BillNo}</span></div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Bill Date: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblBillDate">{moment(fnbCancellationDetails.TransactionDate, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Payment Type: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblPaymentType">{fnbCancellationDetails.PaymentType}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Payment Mode: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblPaymentMode">{fnbCancellationDetails.PaymentMode}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Tracking ID: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblTrackingID">{fnbCancellationDetails.TrackingID}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Order Rate: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;₹ <span id="lblOrderRate">{fnbCancellationDetails.TotalOrderRate}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Total Tax: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;₹ <span id="lbltotalTax">{fnbCancellationDetails.TotalTax}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Bill Amount: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;₹ <span id="lblBillAmount">{fnbCancellationDetails.TotalAmount}</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">User: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblUser">{fnbCancellationDetails.UserName}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Order Type: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblOrderType">{fnbCancellationDetails.Type}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Location: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblLocation">{fnbCancellationDetails.Location}</span></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Slot: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblSlot">{fnbCancellationDetails.Slot}</span></p>
                                        </div>
                                    </div>
                                    <div id="pnlOrderContent"></div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <strong className="margin-0">Order Status: </strong>
                                        </div>
                                        <div className="col-sm-8">
                                            <p className="margin-0">&nbsp;<span id="lblStatus">{fnbCancellationDetails.OrderStatus}</span></p>
                                        </div>
                                    </div> 
                                </div>
                            </div>

                        <h5 id="lblComment" className="margin-tb20">{fnbCancellationDetails.Comment}</h5>

                        <table id="tblOrderItem" className="table table-striped table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Quantity</th>
                                    <th>Rate</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderItem.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.ItemName}</td>
                                        <td>{item.Quantity}</td>
                                        <td>₹ {item.Rate}</td>
                                        <td>₹ {item.Tax}</td>
                                        <td>₹ {item.Total}</td>
                                    </tr>
                                ))} 
                            </tbody>
                        </table>
                        {props.from != "orderReport" && (
                            <form id="fnbCancellationForm">
                                <div className="form-group row">
                                    <label className="col-form-label col-4 text-right">Refund Ref No <span className="red">*</span></label>
                                    <div className="col-6">
                                        <input type="text" className="form-control" id="txtRefNo" name="txtRefNo" value={fnbCancellationDetails.RefundRefNo || ''} onChange={(e) => updateFnbCancellationDetails('RefundRefNo', e.target.value)} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-form-label col-4 text-right">Refund Amount <span className="red">*</span></label>
                                    <div className="col-6">
                                        <input type="text" className="form-control"  id="txtRefAmount" name="txtRefAmount" value={fnbCancellationDetails.RefundAmt || ''} onChange={(e) => updateFnbCancellationDetails('RefundAmt', e.target.value)} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-form-label col-4 text-right">Comment</label>
                                    <div className="col-6">
                                        <textarea className="form-control" rows="2" value={fnbCancellationDetails.RefundComment || ''} onChange={(e) => updateFnbCancellationDetails('RefundComment', e.target.value)}></textarea>
                                    </div>
                                </div>
                            </form>
                        )}
                    </div> 
                    <div className="modal-footer" style={{marginLeft: "auto"}}>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        {props.from != "orderReport" ? <button type="button" className="btn btn-info" onClick={submitFnbCancellation}>Process Refund</button> : <button type="button" className="btn btn-warning" onClick={viewForm}>Invoice</button>}
                    </div>
                </div>
            </div>
        </div>
);
};

export default EditFnbCancellation;
